import { CommandConfigurationProvider } from 'utility-ng-kernel';

angular.module('capability-ng-transfer').config((commandConfigurationProvider: CommandConfigurationProvider) => {
  const DEBOUNCE_TIME = 300;

  commandConfigurationProvider.delay('searchTransferCollegesCommand', DEBOUNCE_TIME);
  commandConfigurationProvider.delay('searchTransferCoursesCommand', DEBOUNCE_TIME);
  commandConfigurationProvider.delay('searchTransferExamsCommand', DEBOUNCE_TIME);
  commandConfigurationProvider.delay('searchTransferMajorsCommand', DEBOUNCE_TIME);
});



// WEBPACK FOOTER //
// ./app/lib/transfer/config/search_command_configuration.ts